import React from "react";
import Input from "../Input/Input";
import { Button } from "antd";

const OrganizationDocumentsUpload = ({ documents }) => {
  return (
    <div className="pt-10">
      <div className="grid grid-cols-2 gap-6">
        <DocumentRow
          label="CIN Number"
          url={documents.CompanyRegisteredAddress}
        />
        <DocumentRow label="VAT Number" url={documents.CompanyTaxId} />
        <DocumentRow label="PAN Number" url={documents.PanId} />
        <DocumentRow label="DUNS Number" url={documents.DunsNumber} />
      </div>
    </div>
  );
};

const DocumentRow = ({ label, url }) => {
  // Extract filename from URL
  const fileName = url ? url.split("/").pop() : "";

  return (
    <div>
      <label className="block text-gray-500 mb-1">{label}</label>
      <div className="flex gap-4">
        <Input
          type="text"
          value={fileName}
          readOnly
          className="w-60"
          variant="secondary"
        />
        {url ? (
          <Button
            type="secondary"
            className="bg-[#0087A3] text-white text-xs w-20 h-7"
            onClick={() => window.open(url, "_blank")}
          >
            View
          </Button>
        ) : (
          <span className="text-red-500 text-xs">Not Available</span>
        )}
      </div>
    </div>
  );
};

export default OrganizationDocumentsUpload;
